export default {
    headers: {
        integratingWithAnApp: {
            id: 'integration.headers.integratingWithAnApp'
        },
        itWillAllowAppTo: {
            id: 'integration.headers.itWillAllowAppTo'
        }
    },
    disclaimers: {
        disconnectApp: {
            id: 'integration.snaq-test.disclaimers.disconnectApp'
        },
        offlineAccess: {
            id: 'integration.snaq-test.disclaimers.offlineAccess'
        }
    },
    labels: {
        integrate: {
            id: 'integration.labels.integrate'
        },
        cancel: {
            id: 'integration.labels.cancel'
        }
    },
    errors: {
        businessErrors: {
            InvalidReturnUrl: {
                id: 'integration.errors.businessErrors.InvalidReturnUrl'
            },
            MissingStorageProvider: {
                id: 'integration.errors.businessErrors.MissingStorageProvider'
            },
            ClientCountryIsNotAllowedForIntegration: {
                id: 'integration.errors.businessErrors.ClientCountryIsNotAllowedForIntegration'
            }
        }
    }
};
